import { library } from '@fortawesome/fontawesome-svg-core'

import { faDownload } from '@fortawesome/pro-solid-svg-icons/faDownload'
import { faFilePdf } from '@fortawesome/pro-solid-svg-icons/faFilePdf'
import { faCalculator } from '@fortawesome/pro-solid-svg-icons/faCalculator'
import { faChevronCircleLeft } from '@fortawesome/pro-solid-svg-icons/faChevronCircleLeft'
import { faChevronCircleRight } from '@fortawesome/pro-solid-svg-icons/faChevronCircleRight'
import { faPalette } from '@fortawesome/pro-solid-svg-icons/faPalette'
import { faTruck } from '@fortawesome/pro-solid-svg-icons/faTruck'
import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus'
import { faPencil } from '@fortawesome/pro-solid-svg-icons/faPencil'
import { faTimes } from '@fortawesome/pro-regular-svg-icons/faTimes'
import { faImage } from '@fortawesome/pro-regular-svg-icons/faImage'
import { faShoppingCart } from '@fortawesome/pro-solid-svg-icons/faShoppingCart'
import { faFileAlt } from '@fortawesome/pro-solid-svg-icons/faFileAlt'
import { faFileInvoice } from '@fortawesome/pro-solid-svg-icons/faFileInvoice'
import { faCalendarAlt } from '@fortawesome/pro-solid-svg-icons/faCalendarAlt'
import { faEnvelope } from '@fortawesome/pro-solid-svg-icons/faEnvelope'
import { faFileContract } from '@fortawesome/pro-solid-svg-icons/faFileContract'
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck'
import { faSearch } from '@fortawesome/pro-solid-svg-icons/faSearch'
import { faCreditCard } from '@fortawesome/pro-solid-svg-icons/faCreditCard'
import { faCopy } from '@fortawesome/pro-solid-svg-icons/faCopy'
import { faSignature } from '@fortawesome/pro-solid-svg-icons/faSignature'
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons/faArrowRight'
import { faDoNotEnter } from '@fortawesome/pro-solid-svg-icons/faDoNotEnter'
import { faBadgePercent } from '@fortawesome/pro-solid-svg-icons/faBadgePercent'
import { faBoxFull } from '@fortawesome/pro-solid-svg-icons/faBoxFull'
import { faUser } from '@fortawesome/pro-solid-svg-icons/faUser'
import { faSitemap } from '@fortawesome/pro-solid-svg-icons/faSitemap'
import { faEmptySet } from '@fortawesome/pro-solid-svg-icons/faEmptySet'
import { faCars } from '@fortawesome/pro-solid-svg-icons/faCars'
import { faPaperPlane } from '@fortawesome/pro-solid-svg-icons/faPaperPlane'
import { faCircle } from '@fortawesome/pro-solid-svg-icons/faCircle'
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons/faCheckCircle'
import { faSync } from '@fortawesome/pro-solid-svg-icons/faSync'
import { faUniversity } from '@fortawesome/pro-solid-svg-icons/faUniversity'

import { faBorderAll } from '@fortawesome/pro-light-svg-icons/faBorderAll'

import { faExpandArrowsAlt } from '@fortawesome/pro-regular-svg-icons/faExpandArrowsAlt'
import { faCircle as faRegularCircle } from '@fortawesome/pro-regular-svg-icons/faCircle'

library.add(
  faDownload, faFilePdf, faCalculator, faChevronCircleLeft, faChevronCircleRight, faPalette, faTruck,
  faBorderAll, faExpandArrowsAlt, faPlus, faPencil, faTimes, faImage, faShoppingCart, faFileAlt, faFileInvoice,
  faCalendarAlt, faEnvelope, faFileContract, faCheck, faSearch, faCreditCard, faCopy, faSignature, faArrowRight,
  faBadgePercent, faBoxFull, faUser, faSitemap, faEmptySet, faCars, faPaperPlane, faDoNotEnter, faCircle,
  faRegularCircle, faCheckCircle, faSync, faUniversity
)
